import * as React from "react";
import {connect} from "react-redux";
import {IReduxState} from "reducers";
import {RouteComponentProps} from "react-router-dom";
import {handleKycNavigation, KycRoutePaths} from "Kyc/route";
import OptionCard from "components/optionCard";
import ContainerBox from "myshubhlife-component/container-box";
import {useState, useEffect} from "react";
import Loading from "components/loading";
import {getKycModes} from "Kyc/api";
import {KycMode, kycModeButtons} from "Kyc/utils";

interface IConnectProps {
  isAndroid: boolean;
  dispatch?: (action: any) => void;
  productCode: string;
}

const KycOptions = (props: IConnectProps & RouteComponentProps) => {
  const [loading, setLoading] = useState(false);
  const [kycModes, setKycModes] = useState<[{mode: string}]>(null);
  useEffect(() => {
    setLoading(true);
    if (props.productCode) {
      getKycModes(props.productCode).then((res) => {
        setLoading(false);
        setKycModes(res.kycModes);
      }).catch((err) => {
        setLoading(false);
      });
    }
  }, [props.productCode]);

  const handleOnBtnClick = (kycMode: {mode: string}) => {
    const currentPath = props.location.pathname;
    const mode = kycMode.mode;
    switch (mode) {
      case KycMode[KycMode.OKYC] : {
        handleKycNavigation(`${currentPath}${KycRoutePaths.OKYC}`);
        break;
      }
      case KycMode[KycMode.Scan] : {
        handleKycNavigation(`${currentPath}${KycRoutePaths.SCAN}`);
        break;
      }
      default: return null;
    }
  };

  const RenderKYCModesSelection = () => {
    if (kycModes && kycModes.length > 0) {
      return (
        <div>
          {kycModes.map((kycMode, index) => {
            const mode = kycMode.mode;
            return(
               <OptionCard
                  key={index}
                  primaryText={kycModeButtons[mode].value}
                  secondaryText={kycModeButtons[mode].description}
                  onClick={() => handleOnBtnClick(kycMode)}/>
            );
          })}
        </div>
      );
    }
  };
  return(
    <>
     <Loading active={loading} />
     {
        kycModes && kycModes.length &&
        <ContainerBox pageTitle="Select KYC Mode" showBackButton={!props.isAndroid}>
           <RenderKYCModesSelection/>
        </ContainerBox>
     }
    </>
  );
};

const mapStateToProps = (state: IReduxState): IConnectProps => {
  return {
    isAndroid : state.login.isAndroid,
    productCode: state.kyc.productCode,
  };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(KycOptions);
